import { takeLatest, call, fork, put } from 'redux-saga/effects';

import { ViewEmailError, ViewEmailSuccess } from '@api/store/emails/actions';
import { viewEmail } from '@api/services/ElasticApi';
import { ShowToast, HideToast } from '@api/store/toast/actions';

function* showEmail(action): any {
    try {
        const email = yield call(viewEmail, action.payload.msgid);
        yield put(ViewEmailSuccess(email.data));
    } catch (e) {
        console.log(e);
        yield put(ViewEmailError());
        yield put(
            ShowToast({
                severity: 'error',
                message: `Error: ${e.response.data.Error}`,
                duration: 6000,
                onClose: HideToast,
            })
        );
    }
}

function* watchShowEmail(): any {
    yield takeLatest('@@emails/VIEW_START', showEmail);
}

const emailsSagas = [fork(watchShowEmail)];

export default emailsSagas;
